import { User } from "@common";
import React from 'react';
import { Navigate } from 'react-router-dom';

export function MPProtectedRoute({ children, user }: IProps) {
    if (!user?.id) {
        return (
            <Navigate
                to="/"
                replace
            />
        );
    }

    return children;
}

export interface IProps {
    user?: Omit<User, "password">;
    children: React.ReactNode;
}
